module.exports = __webpack_public_path__ + "static/img/h-8.9b25e4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/h-8.jpg
// module id = pj/j
// module chunks = 1